import { SettingsRadioItem } from 'modules/settingsContainer/SettingsRadio/types';
import { SortingInterface } from 'modules/visualisations/Table/visualisation/types';

export const sortOptions: SettingsRadioItem<SortingInterface['type']>[] = [
  { value: 'ASC', label: 'По возрастанию' },
  { value: 'DESC', label: 'По убыванию' },
];
